import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';

const Contact = ( ) => {
  return (
    <Container className='contactContentContainer bg-light' fluid>
      <Row className='w-100 m-0 pt-3 pb-3'>
        <Col lg = {12} >
          <h3 className='sectionalText'>Contact Us</h3>
        </Col>
        <Col md={12} lg = {6} className='d-flex justify-content-center align-items-center'>
          <a href="https://www.firstpropertyms.net" className='d-flex align-items-center justify-content-center p-0 m-0'> 
            <img src="./images/FirstPropertyLogo.png" alt=''/>
          </a>
        </Col>
        <Col md={12} lg = {6} className='d-flex justify-content-center align-items-center'>
          <p> 
            <b>First Property Management Solution</b> <br></br>
            <i className="bi bi-pin-map"></i> 525 Milltown Road Suite 402, North Brunswick, NJ 08902<br></br>
            <i className="bi bi-telephone-inbound"></i> (732) 937-5080<br></br>
            <i className="bi bi-envelope-at"></i> Keisha@firstpropertyms.com<br></br>
            <i className="bi bi-translate"></i> Hablamos Espanol<br></br>
          </p>
        </Col>
        <Col lg = {12} >
          <Container className='d-flex justify-content-center align-items-center'>
            <Col lg={10}>
              <p> Whether you’re searching for the perfect retail space for your business or a modern apartment to call home, we have a variety of options that might be exactly what you need. Call us or email for more information or to schedule a tour today! </p>
            </Col>
          </Container>
        </Col>
      </Row>
    </Container> 
  );
};

export default Contact;
